import "textillate";
import "lettering.js";

export default function () {

    function initUserInterface() {
        // bind a click event to the 'skip-nav' link and give focus
        var $this = $(this);
        
        $(".skip-nav").click(function (){
            var skipTo="#"+this.href.split('#')[1];
            $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
                $this.removeAttr('tabindex');
            }).focus();
        });

        // Script to scroll to top after accordion is open to offset the large accordions
        $('.collapse').on('shown.bs.collapse', function() {
            var $card = $(this).closest('.card');
            $('html,body').animate({
                scrollTop: $card.offset().top - 140
            }, 500);
        });

        // $('.career-picker-row a.btn.white').on('click', function() {
        //     $('html,body').animate({
        //         scrollTop: $(this).offset().top
        //     }, 500);
        // });

        //setupSmoothScroll
        var anchorLink = $('.anchor-link');
        if (anchorLink.length > 0) {
            anchorLink.on('click', function (event){
                event.preventDefault();
                var offset = $($(this).attr('href')).offset().top - 100;
                var $offsetTarget = $($(this).attr('href'));
                $('html, body').animate({scrollTop:offset}, 500, function (){
                    $offsetTarget.attr('tabindex', -1).focus();
                });
            });
        }

        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 800) {
                $(".back-to-top").addClass("show");
            } else {
                $(".back-to-top").removeClass("show");
            }
        });

        // Add to Any
        function addToAny() {
            $('<script>var a2a_config = a2a_config || {}; a2a_config.templates = {email: { subject: "${title}", body: "Check out this website: ${link}"}};</' + 'script>').appendTo(document.body);

            var addtoanyScript = document.createElement('script');
            addtoanyScript.setAttribute('src', '//static.addtoany.com/menu/page.js');
            document.body.appendChild(addtoanyScript);
        }

        // Bootstrap Select
        function bootstrapSelect() {
            $('select').selectpicker();

            var $showMore = $('.show-more');
            var $newsSection = $('.news-section');
            var $newsSectionRow = $('.news-section .news-block > .row').not(":eq(0)");

            if ($newsSection.length > 0){
                $newsSectionRow.attr('aria-expanded','false');
                $newsSectionRow.attr('tabindex','-1');
                $newsSectionRow.addClass('hidden');
            }


            $showMore.on('click', function(){
                $newsSection.toggleClass('open-news');

                $newsSectionRow.attr('aria-expanded',
                    $newsSectionRow.attr('aria-expanded')=='false' ? 'true' : 'false'
                );
                $newsSectionRow.attr('tabindex',
                    $newsSectionRow.attr('tabindex')=='-1' ? '0' : '-1'
                );
                $newsSectionRow.toggleClass('hidden');

                $('.more').toggleClass('hide');
                $('.less').toggleClass('hide');
            });

            var $loadMore = $('.load-more');
            var $programDirectory = $('.program-container');
            $loadMore.on('click', function(){
                $programDirectory.toggleClass('show-programs');
            })
        }

        $('.close-alert').on('click', function(){
            $('.alert').toggleClass('closed');
        });

        var $slideUpCards = $('.card-content');
        var $slideUpCardTrigger = $('.tile-link');

        $slideUpCardTrigger.on('click', function() {
            $this.closest($slideUpCards).toggleClass('slide-up');
        });

        function closePreviousCareer() {
            var $myGroup = $('.career-picker-row');
            $myGroup.on('show.bs.collapse','.collapse', function () {
                $myGroup.find('.collapse.show').collapse('hide');
            });
        }

        // Video Transcript button
        $('.play-with-transcript').on('click', function (e) {
            // Play video automatcially
            $('#housingVideo')[0].src += '?autoplay=1';
        })

        // Deep linking
        function deepLinkDegreeTabs() {

            var url = document.location.toString();

            if (url.match('#')) {
                $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
            }

            //Change hash for page-reload
            $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').on('shown', function (e) {
                window.location.hash = e.target.hash;
            });
        }

        // prevent scrolling
        function preventScroll() {
            function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault)
                    e.preventDefault();
                e.returnValue = false;
            }

            function preventDefaultForScrollKeys(e) {
                if (keys[e.keyCode]) {
                    preventDefault(e);
                    return false;
                }
            }

            function disableScroll() {
                if (window.addEventListener) // older FF
                    window.addEventListener('DOMMouseScroll', preventDefault, false);
                window.onwheel = preventDefault; // modern standard
                window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
                window.ontouchmove  = preventDefault; // mobile
                document.onkeydown  = preventDefaultForScrollKeys;
            }

            function enableScroll() {
                if (window.removeEventListener)
                    window.removeEventListener('DOMMouseScroll', preventDefault, false);
                window.onmousewheel = document.onmousewheel = null;
                window.onwheel = null;
                window.ontouchmove = null;
                document.onkeydown = null;
            }
        }

        //refresh page on browser resize while storing window width
        function pageReload() {

            if ($('body').find('.col-slider-l').length) {
                onHomepage();
            }

            function onHomepage() {
                var windowWidth = $(window).width();

                $(window).resize(function(){
                    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
                    if ($(window).width() != windowWidth) {

                        // Update the window width for next time
                        windowWidth = $(window).width();

                        $(window).bind('resize', function () {
                            if (window.RT) clearTimeout(window.RT);
                            window.RT = setTimeout(function () {
                                this.location.reload(false); /* false to get page from cache */
                            }, 100);
                        });
                    }
                });
            }
        }

        function initSwapText() {
            $('.filter-trigger').click(function(){
                var $this = $(this);
                $this.toggleClass('collapsed');
                if($this.hasClass('collapsed')){
                    $this.text('Show More Filters');
                } else {
                    $this.text('Show Fewer Filters');
                }
            });
        }

        addToAny();
        bootstrapSelect();
        deepLinkDegreeTabs();
        preventScroll();
        pageReload();
        initSwapText();
    }

    initUserInterface();

    $( document ).ready(function() {
        if ($('.col-slider-r').length) {
            $('body').addClass('homepage');
        }

        if ($('.bootstrap-select').length > 0) {
            $(this).find('ul.dropdown-menu li').each( function () {
                $(this).find('a').attr('href', "javascript:void(0)");
            });
        }
    });
};



// WEBPACK FOOTER //
// ./src/ui/js/apps/userinterface.js